module.exports = __webpack_public_path__ + "img/draw.fc11f945.png";